export default "/images/ic-pay.svg?2cef46866e8549398db62bc4e40d6333";